import React from "react";

export default function GuidedCircleSVG(params) {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>guide-circle</title>
      <desc>Created with Sketch.</desc>
      <g
        id="Pricing"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="M-Pricing-[range]"
          transform="translate(-185.000000, -321.000000)"
        >
          <g id="Group-9" transform="translate(16.000000, 302.000000)">
            <g id="guide-circle" transform="translate(169.000000, 19.000000)">
              <g id="Group-7">
                <g id="Group">
                  <path
                    d="M16,1.47990554e-14 C20.1710761,1.58206744e-14 23.9693699,1.59607032 26.8174589,4.21078828 C30.0031361,7.13543266 32,11.3345201 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 -9.71384857e-15,24.836556 -7.54951657e-15,16 C-5.38518456e-15,7.163444 7.163444,1.26347234e-14 16,1.47990554e-14 Z M16,12 C13.790861,12 12,13.790861 12,16 C12,18.209139 13.790861,20 16,20 C18.209139,20 20,18.209139 20,16 C20,13.790861 18.209139,12 16,12 Z"
                    id="Combined-Shape"
                    fill="#FFFFFF"
                  ></path>
                  <circle
                    id="Oval"
                    stroke="#677383"
                    strokeWidth="2"
                    cx="16"
                    cy="16"
                    r="15"
                  ></circle>
                </g>
                <g
                  id="Group-2"
                  transform="translate(4.000000, 13.000000)"
                  fill="#677383"
                >
                  <g
                    id="Icon/Arrow/Right"
                    transform="translate(18.000000, 0.000000)"
                  >
                    <path
                      d="M5.62548754,1.3125 L6.375,2.01230498 L3.37695016,4.81152492 L3.375,4.8105 L3.37304984,4.81152492 L0.375,2.01230498 L1.12451246,1.3125 L3.375,3.4135 L5.62548754,1.3125 Z"
                      id="Shape"
                      transform="translate(3.375000, 3.062012) rotate(-90.000000) translate(-3.375000, -3.062012) "
                    ></path>
                  </g>
                  <g id="Icon/Arrow/Left">
                    <path
                      d="M4.87548754,1.3125 L5.625,2.01230498 L2.62695016,4.81152492 L2.625,4.8105 L2.62304984,4.81152492 L-0.375,2.01230498 L0.374512459,1.3125 L2.625,3.4135 L4.87548754,1.3125 Z"
                      id="Shape"
                      transform="translate(2.625000, 3.062012) rotate(-270.000000) translate(-2.625000, -3.062012) "
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
